import { type ReactNode } from 'react';
import { useConfig, useSetConfig } from '../hooks/use-config';
import { ToggleField } from './settings-field';

function parseEnabled(value: unknown): boolean {
  return value === true || value === 'true';
}

export function PipelineToggle(): ReactNode {
  const { data: cfg, isLoading } = useConfig('pipeline_enabled');
  const save = useSetConfig();
  if (isLoading || cfg === undefined) return null;
  const on = cfg === null ? true : parseEnabled(cfg.value);
  const toggle = (v: boolean): void => {
    save.mutate({ key: 'pipeline_enabled', value: v });
  };
  return <ToggleField label="Pipeline" value={on} onChange={toggle} />;
}
